import api from 'api'
import useSWR from 'swr'

/**
 * Topのカルーセルに表示するギャラリー一覧を取得するSWR
 */
export const useTopOwners = (limit?: number) => {
  const keys = ['/owners', limit]
  return useSWR<EventCardType[]>(
    keys,
    ([path, limit]) =>
      api
        .get(path, {
          params: { limit: limit },
        })
        .then((res) => res.data),
    {
      revalidateOnFocus: false,
    },
  )
}
